'use client';

import React from 'react';
import { Search, X, Calendar } from 'lucide-react';

interface Filters {
  search: string;
  dateFrom: string;
  dateTo: string;
  minAmount: string;
  maxAmount: string;
}

interface OrderFiltersProps {
  filters: Filters;
  onChange: (f: Filters) => void;
}

export default function OrderFilters({ filters, onChange }: OrderFiltersProps) {
  const hasActive = filters.search || filters.dateFrom || filters.dateTo || filters.minAmount || filters.maxAmount;

  return (
    <div className="card p-4">
      <div className="flex flex-wrap gap-3 items-center">
        {/* Search */}
        <div className="relative flex-1 min-w-[200px]">
          <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <input
            type="text"
            placeholder="Search by order #, customer name..."
            value={filters.search}
            onChange={(e) => onChange({ ...filters, search: e.target.value })}
            className="input-field pl-9 text-xs h-9"
          />
          {filters.search && (
            <button
              onClick={() => onChange({ ...filters, search: '' })}
              className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
            >
              <X size={13} />
            </button>
          )}
        </div>

        {/* Date from */}
        <div className="relative">
          <Calendar size={13} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <input
            type="date"
            value={filters.dateFrom}
            onChange={(e) => onChange({ ...filters, dateFrom: e.target.value })}
            className="input-field pl-8 text-xs h-9 w-36"
          />
        </div>

        <span className="text-xs text-muted-foreground">to</span>

        {/* Date to */}
        <div className="relative">
          <Calendar size={13} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <input
            type="date"
            value={filters.dateTo}
            onChange={(e) => onChange({ ...filters, dateTo: e.target.value })}
            className="input-field pl-8 text-xs h-9 w-36"
          />
        </div>

        {/* Amount range */}
        <div className="flex items-center gap-2">
          <input
            type="number"
            placeholder="Min PKR"
            value={filters.minAmount}
            onChange={(e) => onChange({ ...filters, minAmount: e.target.value })}
            className="input-field text-xs h-9 w-24 tabular-nums"
          />
          <span className="text-xs text-muted-foreground">–</span>
          <input
            type="number"
            placeholder="Max PKR"
            value={filters.maxAmount}
            onChange={(e) => onChange({ ...filters, maxAmount: e.target.value })}
            className="input-field text-xs h-9 w-24 tabular-nums"
          />
        </div>

        {hasActive && (
          <button
            onClick={() => onChange({ search: '', dateFrom: '', dateTo: '', minAmount: '', maxAmount: '' })}
            className="flex items-center gap-1.5 text-xs text-danger font-medium hover:underline"
          >
            <X size={13} />
            Clear Filters
          </button>
        )}
      </div>
    </div>
  );
}